import {
  emailMessage,
  excludePolishCharsMessage,
  maxLengthMessage,
  requiredMessage,
} from "../validationMessages";
import { emailValidatorRegex } from "../validationRegex";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 50;

export const emailValidator = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(emailValidatorRegex, {
    message: excludePolishCharsMessage,
    excludeEmptyString: true,
  })
  .email(emailMessage);
export const emailValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .email(emailMessage)
  .required(requiredMessage)
  .matches(emailValidatorRegex, excludePolishCharsMessage);
